import script from "./SmishingDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SmishingDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./SmishingDetailsView.vue?vue&type=style&index=0&id=35f65dfa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f65dfa"]])

export default __exports__